"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const SportsConfig_1 = require("../../lib/sports/SportsConfig");
const getCurrentPeriod_1 = require("../../util/summary/getCurrentPeriod");
const camelcase_1 = tslib_1.__importDefault(require("camelcase"));
const regularOnlyFilter = (period) => period.type === 'regular';
const extratimeOnlyFilter = (period) => period.type === 'overtime';
const liveOnlyFilter = (period) => period.status === 'live';
// for cumulative clocks
exports.getMaxPeriodMins = (sportName, periods, currentPeriodCode, config) => {
    const currentPeriod = getCurrentPeriod_1.getCurrentPeriod(currentPeriodCode, periods);
    const livePeriods = periods.filter(liveOnlyFilter);
    const camelName = camelcase_1.default(sportName);
    const regularPeriods = currentPeriod.type === 'overtime'
        ? livePeriods.filter(regularOnlyFilter).length
        : livePeriods
            .filter(({ status }) => status === 'live')
            .reduce(([total, found], { code }) => {
            if (found) {
                return [total, true];
            }
            if (code === currentPeriod.code) {
                return [total + 1, true];
            }
            return [total + 1, false];
        }, [0, false])[0];
    const extratimePeriods = currentPeriod.type === 'regular'
        ? 0
        : livePeriods.filter(extratimeOnlyFilter).reduce(([total, found], { code }) => {
            if (found) {
                return [total, true];
            }
            if (code === currentPeriod.code) {
                return [total + 1, true];
            }
            return [total + 1, false];
        }, [0, false])[0];
    if (SportsConfig_1.sportsConfig[camelName].clock.direction === 'down' || !SportsConfig_1.sportsConfig[camelName].cumulative) {
        if (currentPeriod.type === 'regular') {
            return config.regularPeriodLength;
        }
        return config.extratimePeriodLength;
    }
    if (extratimePeriods) {
        return (regularPeriods * config.regularPeriodLength + extratimePeriods * config.extratimePeriodLength) * 60;
    }
    if (regularPeriods) {
        return regularPeriods * config.regularPeriodLength * 60;
    }
    return 0;
};
//# sourceMappingURL=getMaxPeriodMins.js.map